import { Component, forwardRef, OnInit } from '@angular/core';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SimulationDao } from '@app/dao/simulation/simulation.dao';
import { SimulationType } from '@app/dao/simulation/simulation.interface';
import { Subject } from 'rxjs';
import { EaSimulationFcpiFormBuilder } from './ea-simulation-fcpi-form.builder';

@Component({
    selector: 'ea-simulation-fcpi-form',
    templateUrl: './ea-simulation-fcpi-form.component.html',
    styleUrls: ['./ea-simulation-fcpi-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaSimulationFcpiFormComponent),
        },
    ],
    standalone: false
})
export class EaSimulationFcpiFormComponent
  extends EaSimulationFcpiFormBuilder
  implements OnInit
{
  doneSubject: Subject<void> = new Subject<void>();

  constructor(
    protected formConstructor: PrFormConstructor,
    private simulationDao: SimulationDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {}

  get inCash() {
    return this.form.get('cashOrCredit').value == 'CASH';
  }

  onSubmit() {
    this.prFormService.loading();
    this.simulationDao
      .simulate(null, SimulationType[this.options], this.extract())
      .subscribe(
        success => {
          this.prFormService.loaded();
          this.doneSubject.next();
          if (this.callback) this.callback(success);
          this.notificationService.success('La simulation a réussi');
        },
        errors => {
          console.error(errors);
          this.prFormService.loaded();
          this.notificationService.error('La simulation a échoué');
        },
      );
  }
}
